import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { TransportBailMaster } from '../TitleList';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';

import { selectBalelist, selectParty, selectTransports, selectChanllanId, selectClothIsInfo, selectClothIssue, selectCutReturnlist, selectEmployees, selectFirm, selectItemAvg, selectItems, selectMasterMlist, selectMemoNo, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { errorStyles } from '../../Utils/table';
import { fetchTransportData } from '../../Store/PHPSlice/Transport';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { InsertBailEntry } from '../../Store/PHPSlice/Transport/transportBail';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';



const TransportBailEntry = () => {

    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({

        dt: getCurrentDate(),
        partyId: '',
        transId: '',
        lrno: '',
        totalbail: '',
        userId: userdata?.ID

    });
    const [openDropdowns, setOpenDropdowns] = useState({});

    const actionMap = {
        partyId: fetchPartyData,
        firmId: fetchCompanyData,      // ✅ ADD

        transId: fetchTransportData
        // Add more mappings if needed
    };
    const [itemSize, setItemSize] = useState([]);
    const [gQty, setGQty] = useState([]);
    const [inputValues, setInputValues] = useState([]);

    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const [tableNumSize, setTableNumSize] = useState([]);
    const [itemlist, setItemlist] = useState([]);

    const transportlist = useSelector(selectTransports);


    const partylist = useSelector(selectParty);
    const departList = useSelector(selectDaparement);
    const firmlist = useSelector(selectFirm);

    // console.log(itemSize)
    useEffect(() => {
        dispatch(fetchPartyData());
        dispatch(fetchTransportData());
        dispatch(fetchCompanyData());   // ✅ ADD


        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);




    const handleQtychange = (index, e) => {
        const value = e.target.value;
        if (!/^\d*$/.test(value)) return;

        const maxQty = parseInt(gQty[index], 10);
        const enteredQty = parseInt(value, 10);

        if (enteredQty > maxQty) {
            alert(`Entered quantity (${enteredQty}) cannot be greater than given quantity (${maxQty})`);
            return;
        }
        const updated = [...inputValues];
        updated[index] = value;
        setInputValues(updated);

        const totalQty = updated.reduce((sum, val) => {
            const num = parseInt(val, 10);
            return sum + (isNaN(num) ? 0 : num);
        }, 0);

        setFormData(prev => ({
            ...prev,
            totQty: totalQty
        }));
    };

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDropdownChange = (e, fieldName) => {
        const { value } = e.target;

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };



    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
         if (!formData.firmId) {
            alert("Select Firm");
        }

        else if (!formData.partyId) {
            alert("Select Party");
        }
        else if (!formData.transId) {
            alert("Select Transport");
        }
        else if (!formData.lrno.trim()) {
            alert("Enter LR No");
        }
        else if (!formData.totalbail.trim()) {
            alert("Enter Total Bail");
        }
        else {
            setLoading(true);
            try {
                const result = await dispatch(InsertBailEntry(formData)).unwrap();
                // console.log('POST request successful!', result);
                alert("Transport Bail Details added successfully");
                window.location.reload();
            } catch (error) {
                console.error('Error while making POST request:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleNewParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleNewTransport = () => {
        window.open(`/NewTransportEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    }

    const dropdownEmployeelist = [
         // ✅ FIRM DROPDOWN
    {
        label: 'Firm Name',
        id: 'firmId',
        options: firmlist?.data,
        value: formData.firmId,
        onChange: (newValue) =>
            handleDropdownChange(
                { target: { name: 'firmId', value: newValue ? newValue.ID : '' } },
                'firmId'
            ),
        getOptionLabel: (option) => option.firmNm || '',
        isOptionEqualToValue: (option, value) => option.ID === value,
        valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
        btnlabel: '',
        handleDropdownOpen: () => handleDropdownOpen('firmId'),
        handleDropdownClose: () => handleDropdownClose('firmId'),
    },
        {
            label: 'Party Name',
            id: 'partyId',
            options: partylist?.data,
            value: formData.partyId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () => handleNewParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('partyId'),
            handleDropdownClose: () => handleDropdownClose('partyId'),
        },

        {
            label: 'Transport Name',
            id: 'transId',
            options: transportlist?.data,
            value: formData.transId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'transId', value: newValue ? newValue.ID : '' } }, 'transId'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () => handleNewTransport(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('transId'),
            handleDropdownClose: () => handleDropdownClose('transId'),
        }
    ];






    return (
        <>
            <Titlebar data={TransportBailMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Transport Bail Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }
                                {[

                                    { label: 'Total Bail', name: 'totalbail' },
                                    { label: 'LR No', name: 'lrno' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {itemSize.length > 0 && (
                                    <Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                        {itemSize.map((size, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                {size}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {formData?.ordType !== '0' && (
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                Given Qty.
                                                            </TableCell>
                                                            {gQty.map((qty, index) => (
                                                                <TableCell
                                                                    key={index}
                                                                    sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                    align='center'
                                                                >
                                                                    {qty}
                                                                </TableCell>
                                                            ))}
                                                        </TableRow>
                                                    )}

                                                    <TableRow>
                                                        <TableCell
                                                            sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                            align='center'
                                                        >
                                                            Return Qty.
                                                        </TableCell>
                                                        {inputValues.map((val, index) => (
                                                            <TableCell
                                                                key={index}
                                                                sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                                align='center'
                                                            >
                                                                <input
                                                                    type="number"
                                                                    value={val}
                                                                    placeholder="0"
                                                                    onChange={(e) => handleQtychange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                )}


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default TransportBailEntry;
